export enum KycStatus {
  INITIAL_MISSING_DATA = 'payout:status_missing_data',
  UPDATE_MISSING_DATA = 'payout:status_missing_data',
  REGULAR_MISSING_DATA = 'payout:status_missing_data',
  IN_PROGRESS = 'payout:status_in_progress',
  PASSED = 'payout:status_active',
  FAILED = 'payout:status_failed',
  REJECTED = 'payout:status_rejected',
}

export enum KycStatusInfo {
  MISSING_DATA_MISSING_ID_DOCUMENT = 'payout:status_info_missing_data_missing_id_document',
  MISSING_DATA_MISSING_EXT_DOCUMENT = 'payout:status_info_missing_data_missing_ext_document',
  MISSING_DATA_ADDRESS_MISSMATCH = 'payout:status_info_missing_data_address_mismatch',
  MISSING_DATA_OUTDATED_ACC_DOCUMENT = 'payout:status_info_missing_data_outdated_acc_document',
  MISSING_DATA_OUTDATED_DOCUMENT = 'payout:status_info_missing_data_outdated_document',
  MISSING_DATA_ID_DOCUMENT_UNREADABLE = 'payout:status_info_missing_data_id_document_unreadable',
  MISSING_DATA_EXT_ACCOUNT_DOCUMENT_UNREADABLE = 'payout:status_info_missing_data_ext_account_document_unreadable',
  MISSING_DATA_EXT_ACCOUNT_MISSING_IBAN = 'payout:status_info_missing_data_ext_account_missing_IBAN',
  MISSING_DATA_EXT_DOCUMENT_MISSING_ISSUE_DATE = 'payout:status_info_missing_data_ext_document_missing_issue_date',
  MISSING_DATA_MISSING_UBO_INFORMATION = 'payout:status_info_missing_data_missing_UBO_information',
  MISSING_DATA_COMPANY_STRUCTURE = 'payout:status_info_missing_data_company_structure',
  MISSING_DATA_ADDITIONAL_INFORMATION_REQUIRED = 'payout:status_info_missing_data_additional_information_required',
  FAILED_NAME_MISMATCH = 'payout:status_info_failed_name_mismatch',
  FAILED_EXPIRED_COMPANY_REGISTRATION = 'payout:status_info_failed_expired_company_registration',
  FAILED_NAME_DESCREPTANCY = 'payout:status_info_failed_name_discrepancy',
  FAILED_MISSING_BANK_STATEMENT = 'payout:status_info_failed_missing_bank_statement',
  UNKNOWN_ERROR = 'payout:status_info_unknown_error',
  MISSING_ACCOUNT_DATA = 'payout:status_info_missing_account_data',
}
